<div>
  <h2
    mat-dialog-title
    style="color: white"
    class="title-text theme-background-color mb-4">
    Confirmation
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="row">
      <div class="col-md-12" style="position: relative; top: 14px; left: 10px">
        <div class="form-group">
          <p>{{ data.message }}</p>
        </div>

        <!-- Wrap FINANCE module form section inside formGroup -->
        <div class="mb-3" *ngIf="data?.module === 'FINANCE'" [formGroup]="form">
          <label for="currency-radio-group">Currency:</label>
          <br />

          <mat-radio-group
            id="currency-radio-group"
            formControlName="showUsd"
            name="currency">
            <mat-radio-button color="primary" [value]="false"
              >SAR</mat-radio-button
            >
            <mat-radio-button color="primary" [value]="true"
              >SAR and USD</mat-radio-button
            >
          </mat-radio-group>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions style="gap: 4px" class="flex-d" align="end">
    <button class="btn btn-secondary" [mat-dialog-close]="false">Cancel</button>

    <button
      class="btn btn-primary custom-button"
      [disabled]="module === 'FINANCE' && form.invalid"
      (click)="onSubmit()">
      Confirm
    </button>
  </mat-dialog-actions>
</div>
